'use strict';

var React = require('react');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

function SvgValidateInstructions(props) {
    return (React__default.default.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", ...props },
        React__default.default.createElement("g", { fill: "none", fillRule: "evenodd" },
            React__default.default.createElement("path", { d: "M0 0h16v16H0z" }),
            React__default.default.createElement("path", { d: "M2 2h12v12H2z" }),
            React__default.default.createElement("path", { d: "M11.993 2c.591 0 1.082.456 1.137 1.033l.006.11v9.714c0 .592-.456 1.082-1.033 1.138l-.11.005h-8a1.147 1.147 0 01-1.138-1.033l-.005-.11V3.143c0-.592.456-1.082 1.033-1.138L3.993 2h8zm-1.934 4.41a.76.76 0 01.83-.002l.065.051.047.05a.626.626 0 01-.078.858L7.733 10.3l-.095.075a.873.873 0 01-1.078-.08L5.485 9.256l-.068-.076a.635.635 0 010-.793l.045-.05.068-.051a.722.722 0 01.897.09l.709.704 2.834-2.6zM9.39 3a.643.643 0 010 1.286H6.493a.643.643 0 010-1.286H9.39z", fill: "currentColor" }))));
}

module.exports = SvgValidateInstructions;
//# sourceMappingURL=ValidateInstructions.js.map
